<template>
  <div class="sale-stat-wrapper">
    <!-- 顶部：子标签 + 时间筛选 -->
    <div class="sale-stat">
      <div class="sale-stat-tabs">
        <div
          v-for="tab in saleStatTabs"
          :key="tab.key"
          class="sale-stat-tab"
          :class="{ active: saleStatActive === tab.key }"
          @click="saleStatActive = tab.key"
        >
          {{ tab.label }}
        </div>
      </div>
      <div class="sale-stat-actions">
        <a-radio-group size="small" :value="saleStatRange">
          <a-radio-button value="日">日</a-radio-button>
          <a-radio-button value="周">周</a-radio-button>
          <a-radio-button value="月">月</a-radio-button>
          <a-radio-button value="年">年</a-radio-button>
        </a-radio-group>
        <a-select size="small" :value="saleStatMonth" class="filter-select">
          <a-select-option value="2024-08">2024-08</a-select-option>
        </a-select>
      </div>
    </div>
    <!--    概况-->
    <div v-show="saleStatActive==='overdiv'" class="item" >
      <div class="sale-section">
        <div class="sale-section-title">概况</div>
        <div class="overview-row">
          <div class="overview-label">销售额</div>
          <div class="overview-value" @click="jumpDetail('SALE')">
            {{ data.overdiv.count }}套 / {{ calcNumber(data.overdiv.totalAmount) }}
          </div>
        </div>
        <div class="overview-row overview-row-sub">
          <div class="overview-sub">
            {{ dicObj[selected].type }} ~{{ data.overdiv.rate | filter_rate }}
          </div>
          <div class="overview-sub-value">
            {{ data.overdiv.lastCount }}套/{{ calcNumber(data.overdiv.lastTotalAmount) }}
          </div>
        </div>

        <div class="overview-row" style="margin-top: 20px">
          <div class="overview-label">项目回款</div>
          <div class="overview-value" @click="jumpDetail('SALE')">
            {{ '项目欠款'}}
          </div>
        </div>

        <div class="overview-row overview-row-sub">
          <div class="overview-sub">
            {{ data.overdiv.count }}套 / {{ calcNumber(data.overdiv.totalAmount) }}
          </div>
          <div class="overview-sub-value">
            {{ data.overdiv.lastCount }}套/{{ calcNumber(data.overdiv.lastTotalAmount) }}
          </div>
        </div>
      </div>
    </div>

    <!-- 房款统计 -->
    <div  class="sale-section">
      <div class="sale-section-title">房款统计</div>
      <div class="sale-payments">

        <div class="sale-row">
          <div class="payment-item">
            <div class="payment-title">本月认购</div>
            <div class="payment-value">{{ salePayment.subscription }}</div>
            <div class="payment-sub">认购目标：{{ salePayment.subscriptionTarget }}</div>
          </div>
          <div class="payment-progress">
            <a-progress type="circle" :percent="salePaymentProgress" :width="80" />
            <div class="payment-progress-label">完成率</div>
          </div>
        </div>

        <div class="sale-row">
          <div class="payment-item">
            <div class="payment-title">本月认购</div>
            <div class="payment-value">{{ salePayment.received }}</div>
            <div class="payment-sub">回款目标：{{ salePayment.receivedTarget }}</div>
          </div>
          <div class="payment-progress">
            <a-progress type="circle" :percent="salePaymentProgress" :width="80" />
            <div class="payment-progress-label">完成率</div>
          </div>
        </div>

        <div class="sale-row">
          <div class="payment-item payment-bg" >
            <div class="payment-title">累计房款欠款</div>
            <div class="payment-value">{{ salePayment.received }}</div>
          </div>

          <div class="payment-item payment-bg">
            <div class="payment-title">银行房款</div>
            <div class="payment-value">{{ salePayment.received }}</div>
          </div>
        </div>

        <div class="sale-row">
          <div class="payment-item payment-bg" >
            <div class="payment-title">累计银行待放款</div>
            <div class="payment-value">{{ salePayment.received }}</div>
          </div>

          <div class="payment-item payment-bg">
            <div class="payment-title">退房</div>
            <div class="payment-value">{{ salePayment.received }}</div>
          </div>
        </div>

      </div>
    </div>

    <div  class="sale-section">
      <div class="sale-section-title">地下室/车位统计</div>
      <div class="sale-payments">

        <div class="sale-row">
          <div class="payment-item payment-bg" >
            <div class="payment-title">车位回款</div>
            <div class="payment-value">{{ salePayment.received }}</div>
          </div>

          <div class="payment-item payment-bg">
            <div class="payment-title">地下室回款</div>
            <div class="payment-value">{{ salePayment.received }}</div>
          </div>
        </div>

        <div class="sale-row">
          <div class="payment-item payment-bg" >
            <div class="payment-title">累计车位欠款</div>
            <div class="payment-value">{{ salePayment.received }}</div>
          </div>

          <div class="payment-item payment-bg">
            <div class="payment-title">累计地下室欠款</div>
            <div class="payment-value">{{ salePayment.received }}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaleStatTab',

  data() {
    return {
      // 子标签状态
      saleStatActive: 'overdiv',
      // 时间筛选
      saleStatRange: '月',
      saleStatMonth: '2024-08',
      // 子标签列表
      saleStatTabs: [
        { key: 'overdiv', label: '概况' },
        { key: 'payment', label: '房款统计' },
        { key: 'parking', label: '车位/地下室统计' },
        { key: 'performance', label: '业绩分析' }
      ],
      // 概况数据
      saleOverdiv: {
        monthSales: '86套 / 1223.68万',
        monthSalesChange: '11%',
        projectCollection: '86套 / 1223.68万',
        projectDebt: '80套 / 1223.68万'
      },
      // 房款统计数据
      salePayment: {
        subscription: '86套 / 1223.68万',
        subscriptionTarget: '90套',
        received: '86套 / 1223.68万',
        receivedTarget: '90套'
      },
      salePaymentProgress: 64,
      data:{
        overdiv:{
          totalAmount:0,
      count:0,
      rate:0,
      lastTotalAmount:0,
      lastCount:0,
      paymentAmount:0,
      paymentCount:0,
          paymentDebt:0,

        }
      },
      dicObj: {
        day: { id: 1, type: "较昨日" },
        week: { id: 2, type: "较上周" },
        month: { id: 3, type: "较上月" },
        year: { id: 4, type: "较去年" },
        custom: { id: 5, type: "自定义" },
      }, // 较昨日、较上周、较上月、较去年
      selected: "month", // 选择时间
    }
  },
  filters: {
    filter_rate(value) {
      if (value > 0) {
        return value + "%";
      } else {
        return value + "%";
      }
    },
  },
  methods:{
    /**
     * 值换算
     * @param num
     * @returns {number}
     */
    calcNumber(num) {
      return num + "元";
    },
    jumpDetail(){

    }
  }
}
</script>

<style lang="less" scoped>
.sale-stat {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.sale-stat-tabs {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #5b6b7c;
}

.sale-stat-tab {
  padding: 4px 0;
  cursor: pointer;
  position: relative;
}

.sale-stat-tab.active {
  color: #1f2f3d;
  font-weight: 600;
}

.sale-stat-tab.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px;
  height: 3px;
  border-radius: 2px;
  background: #2b6de5;
}

.sale-stat-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.overview-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 6px 0 10px;
}

.overview-title-text {
  font-weight: 600;
  color: #1f2f3d;
}

.overview-title-icon {
  font-size: 12px;
  color: #9aa5b1;
}

.overview-card {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}

.overview-row {
  display: flex;
  align-items: center;
  padding: 0 100px;
  justify-content: space-between;
}

.overview-row-sub {
  margin-top: 6px;
}

.overview-label {
  font-size: 12px;
  color: #5b6b7c;
}

.overview-value {
  font-size: 13px;
  font-weight: 600;
  color: #2b6de5;
}

.overview-sub {
  font-size: 12px;
  color: #9aa5b1;
}

.overview-sub-value {
  font-size: 12px;
  color: #5b6b7c;
}

.overview-split {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.overview-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sale-section {
  background: #ffffff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #f0f0f0;
}

.sale-section-title {
  font-weight: 600;
  color: #1f2f3d;
  margin-bottom: 10px;
}

.sale-overdiv {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.overdiv-item {
  padding: 10px;
  border-radius: 8px;
  background: #f7f9fc;
}

.overdiv-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.overdiv-title {
  color: #5b6b7c;
  font-size: 12px;
}

.overdiv-value {
  color: #1f2f3d;
  font-weight: 600;
}

.overdiv-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #7a8699;
}

.sale-payments {
  //display: flex;
  //justify-content: space-between;
  //gap: 12px;
  //align-items: center;
}
.sale-row{
  padding: 0 100px;
  display: flex;
  //align-items: center;
  justify-content: space-between;
  &:last-child{
    margin-top: 20px;
  }
}

.payment-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  flex: 1;
}

.payment-item {
  border-radius: 8px;
  padding: 10px;
}
.payment-bg{
  background: #f9f9f9;
}

.payment-item2{
  background: #f9f9f9;
}

.payment-title {
  font-size: 12px;
  color: #7a8699;
}

.payment-value {
  font-weight: 600;
  color: #1f2f3d;
  margin-top: 6px;
}

.payment-sub {
  font-size: 12px;
  color: #9aa5b1;
  margin-top: 4px;
}

.payment-progress {
  width: 120px;
  text-align: center;
}

.payment-progress-label {
  font-size: 12px;
  color: #7a8699;
  margin-top: 6px;
}

.title-box {
  display: flex;
  align-items: center;

  :nth-child(2) {
    padding: 15px 15px;
  }
}

.general-box {
  margin-top: 16px;
  padding: 30px 0;
  border-radius: 10px;
  display: flex;

  .img-box {
    width: 56px;
    display: flex;
    justify-content: center;
    align-items: center;

    > image {
      width: 56px;
      height: 56px;
    }
  }

  .statistics {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 40px;
    .margin-left-60 {
      margin-left: 40px;
    }
    .zd-box {
      display: flex;
      align-items: center;
      image {
        width: 16px;
        height: 16px;
        margin: 0 10px;
        vertical-align: bottom;
      }
      .zhang {
        transform: rotateX(180deg);
      }
    }
    > view {
      display: flex;
      > view {
        flex-grow: 1;
        width: 50%;
      }
    }
  }
}

.general-box:nth-child(2) {
  margin-top: 0;
}
</style>
